import React from 'react';
import { Button } from 'primereact/button';
import { Content, Parallax } from "../../App";
import { Grid } from "../home";
import SelfHarvestFormula from "../../components/SelfHarvestFormula";
import { Questions } from "../BasketsPage/BasketsPage2";
import Footer from "../../components/Footer";

const signupUrl = 'https://www.mijnboer.be/groentegeweld/inschrijven/zelfoogst';

const featureCardClassName = [
  'surface-card',
  'border-1',
  'border-200',
  'border-round-2xl',
  'shadow-2',
  'overflow-hidden',
].join(' ');

const sectionCardClassName = [
  'surface-card',
  'border-1',
  'border-200',
  'border-round-2xl',
  'shadow-1',
  'p-3',
  'md:p-5',
].join(' ');

const SelfHarvestPage = () => {
  return (
    <div>
      <section className="relative overflow-hidden">
        <Parallax img={'IMG_7906.jpeg'} height={'70vh'} />
        <div className="absolute top-0 left-0 right-0 bottom-0 flex align-items-center">
          <div
            className="w-full"
            style={{
              background: 'linear-gradient(90deg, rgba(0,0,0,0.76) 0%, rgba(0,0,0,0.42) 58%, rgba(0,0,0,0.12) 100%)',
            }}
          >
            <Content>
              <div className="py-6 md:py-8 text-white" style={{ maxWidth: '780px' }}>
                <div
                  className="inline-flex align-items-center gap-2 px-3 py-2 border-round-3xl mb-4"
                  style={{ background: 'rgba(255,255,255,0.20)', backdropFilter: 'blur(8px)' }}
                >
                  <i className="pi pi-leaf" />
                  <span className="font-medium">Zelf oogsten • recht van het veld • kraakvers</span>
                </div>

                <h1 className="m-0 mb-3 text-4xl md:text-6xl line-height-1 font-bold">
                  Zelfoogst
                </h1>

                <p className="text-lg md:text-2xl line-height-3 mb-4" style={{ maxWidth: '700px' }}>
                  Kom oogsten wanneer het jou past. Wandel door onze openlucht groentewinkel, kies wat je gezin nodig
                  heeft en neem het allerverse mee naar huis.
                </p>

                <div className="flex flex-wrap gap-3 mb-4">
                  <span className="px-3 py-2 border-round-3xl font-medium" style={{ background: 'rgba(255,255,255,0.22)' }}>
                    Dagelijks open
                  </span>
                  <span className="px-3 py-2 border-round-3xl font-medium" style={{ background: 'rgba(255,255,255,0.22)' }}>
                    Voor je eigen gezin
                  </span>
                  <span className="px-3 py-2 border-round-3xl font-medium" style={{ background: 'rgba(255,255,255,0.22)' }}>
                    Met nieuwsbrief en kleurcodes
                  </span>
                </div>

                <Button
                  label={'Ja, ik word zelfoogster'}
                  icon={'pi pi-arrow-right'}
                  iconPos={'right'}
                  className={'color-white bg-orange p-button-lg'}
                  onClick={() => window.open(signupUrl, '_blank')}
                />
              </div>
            </Content>
          </div>
        </div>
      </section>

      <Content>
        <div className="py-5 md:py-6">
          <div className="grid align-items-center">
            <div className="col-12 lg:col-7">
              <div className={sectionCardClassName}>
                <div
                  className="inline-flex align-items-center gap-2 px-3 py-2 border-round-3xl mb-4"
                  style={{ background: 'var(--green-20)' }}
                >
                  <i className="pi pi-shopping-bag" />
                  <span className="font-medium">Openlucht groentewinkel</span>
                </div>

                <h2 className="mt-0 mb-3 text-3xl md:text-4xl">
                  Pluk met je eigen handen, recht van het veld
                </h2>

                <p className="text-lg line-height-3 mb-3">
                  Hou je van ontdekken wat er op het veld te vinden valt? Geniet je van rust, frisse lucht en groenten
                  die écht vers zijn? Dan ben je waarschijnlijk een geboren zelfoogster.
                </p>

                <p className="text-lg line-height-3 mb-3">
                  Als zelfoogster kom je naar ons veld en oogst je zelf wat je nodig hebt. Je kiest wanneer je komt,
                  wat je meeneemt en hoeveel past bij jouw gezin. Verser wordt het niet.
                </p>

                <p className="text-lg line-height-3 mb-0">
                  Breng zelf een mes mee en zakjes of bakjes voor je groenten. Rieken, spades en een kruiwagen vind je
                  gewoon bij ons op het veld.
                </p>
              </div>
            </div>

            <div className="col-12 lg:col-5">
              <div className={featureCardClassName}>
                <img
                  src={'IMG_7133.jpeg'}
                  alt={'Zelfoogst op het veld'}
                  className="block w-full"
                  style={{ height: '100%', minHeight: '360px', objectFit: 'cover' }}
                />
              </div>
            </div>
          </div>

          <div className="grid mt-4 md:mt-5">
            <div className="col-12 md:col-4">
              <div className={sectionCardClassName + ' h-full'}>
                <i className="pi pi-clock text-3xl color-orange" />
                <h3 className="mb-2 text-2xl">Wanneer jij wil</h3>
                <p className="line-height-3 mb-0">
                  Ons veld is dagelijks open van zonsopgang tot zonsondergang, uitgezonderd zondagnamiddag.
                </p>
              </div>
            </div>

            <div className="col-12 md:col-4">
              <div className={sectionCardClassName + ' h-full'}>
                <i className="pi pi-users text-3xl color-orange" />
                <h3 className="mb-2 text-2xl">Voor je gezin</h3>
                <p className="line-height-3 mb-0">
                  Hoeveel je plukt, hangt af van je gezinsgrootte. Je oogst enkel voor je eigen gezin.
                </p>
              </div>
            </div>

            <div className="col-12 md:col-4">
              <div className={sectionCardClassName + ' h-full'}>
                <i className="pi pi-heart text-3xl color-orange" />
                <h3 className="mb-2 text-2xl">Kindvriendelijk</h3>
                <p className="line-height-3 mb-0">
                  Er is een zandbak en een schommel. En soms valt er ook iets lekkers te snoepen op het veld.
                </p>
              </div>
            </div>
          </div>
        </div>
      </Content>

      <Content>
        <div className="py-4 md:py-6">
          <div className="grid align-items-center">
            <div className="col-12 lg:col-8">
              <SelfHarvestFormula />
            </div>

            <div className="col-12 lg:col-4">
              <div
                className={sectionCardClassName}
                style={{
                  background: 'linear-gradient(135deg, rgba(116, 143, 86, 0.10) 0%, rgba(238, 122, 49, 0.08) 100%)',
                }}
              >
                <div
                  className="inline-flex align-items-center gap-2 px-3 py-2 border-round-3xl mb-4"
                  style={{ background: 'var(--orange-20)' }}
                >
                  <i className="pi pi-plus-circle" />
                  <span className="font-medium">Aangevuld met...</span>
                </div>

                <h2 className="mt-0 mb-3 text-3xl">Ook handig in huis</h2>

                <p className="text-lg line-height-3 mb-0">
                  Basisproducten zoals <strong>eieren, aardappelen of uien</strong> kan je ook bij ons bestellen.
                  We produceren ze meestal niet op eigen veld, maar laten dit doen door bevriende bioboeren uit de buurt.
                  Wij zetten ze wekelijks, tweewekelijks of maandelijks voor je klaar.
                </p>
              </div>
            </div>
          </div>
        </div>
      </Content>

      <section className="my-4 md:my-6">
        <Parallax img={'zonnebloem.jpg'} height={'220px'} />
      </section>

      <Content>
        <div className="py-4 md:py-6">
          <div className="mb-4 flex flex-column align-items-center text-center">
            <div
              className="inline-flex align-items-center gap-2 px-3 py-2 border-round-3xl mb-3"
              style={{ background: 'var(--green-20)' }}
            >
              <i className="pi pi-info-circle" />
              <span className="font-medium">Hoe werkt het?</span>
            </div>

            <h2 className="mt-0 mb-2 text-3xl md:text-4xl">
              Je weet altijd wat je mag oogsten
            </h2>

            <p className="m-0 text-lg line-height-3" style={{ maxWidth: '760px' }}>
              Via onze nieuwsbrief en via kleurcodes op het veld tonen we wat klaar is om te oogsten.
            </p>
          </div>

          <div className="grid">
            <div className="col-12 md:col-4">
              <div className={sectionCardClassName + ' h-full'}>
                <div className="inline-flex align-items-center gap-2 mb-3">
                  <span
                    className="inline-block border-circle"
                    style={{ width: '18px', height: '18px', backgroundColor: 'red' }}
                  />
                  <h3 className="m-0 text-2xl">Rood</h3>
                </div>
                <p className="line-height-3 mb-0">
                  Nog niet oogsten. Deze groenten hebben nog even tijd nodig.
                </p>
              </div>
            </div>

            <div className="col-12 md:col-4">
              <div className={sectionCardClassName + ' h-full'}>
                <div className="inline-flex align-items-center gap-2 mb-3">
                  <span
                    className="inline-block border-circle"
                    style={{ width: '18px', height: '18px', backgroundColor: '#f5d742' }}
                  />
                  <h3 className="m-0 text-2xl">Geel</h3>
                </div>
                <p className="line-height-3 mb-0">
                  Oogstklaar voor direct vers gebruik. Ideaal om dezelfde dag nog op je bord te leggen.
                </p>
              </div>
            </div>

            <div className="col-12 md:col-4">
              <div className={sectionCardClassName + ' h-full'}>
                <div className="inline-flex align-items-center gap-2 mb-3">
                  <span
                    className="inline-block border-circle"
                    style={{ width: '18px', height: '18px', backgroundColor: 'green' }}
                  />
                  <h3 className="m-0 text-2xl">Groen</h3>
                </div>
                <p className="line-height-3 mb-0">
                  Oogstklaar en dit veldje mag leeg. Perfect moment om soep of voorraad voor je vriezer te maken.
                </p>
              </div>
            </div>
          </div>

          <div className="grid mt-4 md:mt-5 align-items-center">
            <div className="col-12 lg:col-5">
              <div className={featureCardClassName}>
                <img
                  src={'IMG_7041.jpg'}
                  alt={'Zelfoogsters op het veld'}
                  className="block w-full"
                  style={{ height: '100%', minHeight: '320px', objectFit: 'cover' }}
                />
              </div>
            </div>

            <div className="col-12 lg:col-7">
              <div className={sectionCardClassName}>
                <div
                  className="inline-flex align-items-center gap-2 px-3 py-2 border-round-3xl mb-4"
                  style={{ background: 'var(--orange-20)' }}
                >
                  <i className="pi pi-compass" />
                  <span className="font-medium">Op het veld</span>
                </div>

                <h2 className="mt-0 mb-3 text-3xl md:text-4xl">
                  Korter wordt de voedselketen niet
                </h2>

                <p className="text-lg line-height-3 mb-3">
                  Op ons veld kom je andere zelfoogsters tegen, maar ook boeren Willem en Dirk. Je kent dus écht de boer
                  die jouw net getrokken prei geplant heeft.
                </p>

                <ul className="m-0 pl-3 text-lg line-height-3">
                  <li>Blijf tijdens het oogsten op de paadjes, zodat de bodem luchtig blijft.</li>
                  <li>Bloemen snijden kan enkel met een bloemenabonnement.</li>
                  <li>Oogst met zorg, zodat iedereen kan meegenieten van het veld.</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </Content>

      <Content>
        <div className="py-4 md:py-6">
          <div
            className="border-round-2xl shadow-2 p-4 md:p-6 text-center"
            style={{
              background: 'linear-gradient(135deg, rgba(116, 143, 86, 0.18) 0%, rgba(238, 122, 49, 0.14) 100%)',
            }}
          >
            <div
              className="inline-flex align-items-center gap-2 px-3 py-2 border-round-3xl mb-4"
              style={{ background: 'rgba(255,255,255,0.65)' }}
            >
              <i className="pi pi-check-circle" />
              <span className="font-medium">Klaar om mee te doen?</span>
            </div>

            <h2 className="mt-0 mb-3 text-3xl md:text-4xl">
              Ja, ik word zelfoogster!
            </h2>

            <p className="text-lg line-height-3 mx-auto mb-4" style={{ maxWidth: '720px' }}>
              Schrijf je in via MijnBoer. Zodra je inschrijving verwerkt is, kan je komen oogsten.
            </p>

            <Button
              label={'Naar het inschrijvingsformulier'}
              icon={'pi pi-external-link'}
              iconPos={'right'}
              className={'color-white bg-orange p-button-lg'}
              onClick={() => window.open(signupUrl, '_blank')}
            />
          </div>
        </div>
      </Content>

      <Content>
        <div className="">
          <Questions
            className="border-round-2xl shadow-2 p-4 md:p-5"
            style={{
              background: 'linear-gradient(135deg, rgba(116, 143, 86, 0.18) 0%, rgba(238, 122, 49, 0.14) 100%)',
            }}
          >
            <div
              className="inline-flex align-items-center gap-2 px-3 py-2 border-round-3xl mb-3"
              style={{ background: 'rgba(255,255,255,0.65)' }}
            >
              <i className="pi pi-question-circle" />
              <span className="font-medium">Nog vragen?</span>
            </div>

            <h3 className="mt-0 mb-2 text-2xl md:text-3xl">
              Zit je nog met vragen?
            </h3>

            <p className="m-0 text-lg line-height-3">
              Aarzel niet om ons te{' '}
              <a className="color-orange font-bold" href={'mailto:info@groentegeweld.be'}>
                contacteren
              </a>
              .
            </p>
          </Questions>
        </div>
      </Content>

      <Footer />
    </div>
  );
};

export default SelfHarvestPage;
